export default __webpack_public_path__ + "static/media/Image-Register.a724d10c.png";